import { useSelector } from "react-redux";
import MovieList from "./MovieList";

const SecondaryContainer = () => {
  const movies = useSelector((store) => store.movies);

  return (
    movies.nowPlayingMovies && (
      <div className="bg-black mt-0 sm:mt-16 w-screen">
        <div className=" mt-0 md:-mt-52 pl-2 md:pl-12 relative z-20">
          <MovieList title={"Now Playing"} movies={movies.nowPlayingMovies} />
          <MovieList title={"Populer Movies"} movies={movies.nowPopularMovies} />
        </div>
      </div>
    )
  );
};
export default SecondaryContainer;